import React from 'react';
import NhiemVuTTXM from './NhiemVuTTXM.jsx';
import {Link, browserHistory} from 'react-router';
import {
  // DropDownChonKetLuanNoiDungKhieuNai,
  DropDownMulipleUse
} from 'components/tt-forms';
import moment from 'moment';
import {ContainerFileDinhKem} from 'components/upload';
import { GiaiQuyetDonThu } from 'api';
import { ShowIf } from 'components/utils';
import {TextArea, Text, TextMessage} from 'components/tt-forms/common';
import ConfirmDialog from './ConfirmDialog.jsx';
import {
  getParams
} from 'modules/giai-quyet-don/subView/GetParams.jsx';

const loaiTepDinhKem = 'QUYET_DINH';
const loaiQuyTrinh = 'THAM_TRA_XAC_MINH';
const buocGiaiQuyet = null;

class NhapThongTinToTTXX extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      id: this.props.id,
      loaiDon: this.props.loaiDon,
      isValid: false,
      btnLoading: false,
      btnSaveLoading: false,
      openDialog: false,
      openDialogTraDon: false,
      onSave: false,

      lapToDoanXacMinh: false,

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      nextState: 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET',
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,

      soQuyetDinhThanhLapDTXM: '',
      truongDoanTTXM: '',

      ketLuanNoiDungKhieuNaiGiaoTTXM: '',
      noiDung: '',
      yKienGiaiQuyet: '',

      ngayHetHanSauKhiGiaHanTTXM: '',
      lyDoGiaHanTTXM: '',
      ngayHetHanSauKhiGiaHanGiaiQuyet: '',
      lyDoGiaHanGiaiQuyet: '',

      donViId: '',
      giaHanTTXM: false,
      giaHanGiaiQuyet: false,
      dataNextStatesTXL: [],
      ListTaiLieuVanThu: [],
      ListTaiLieuVanThuShow: [],
      dataNextState: [],
      showAttach: false,
      lyDoQuaHan: ''
    }
  }

  componentWillMount() {
    this.determinativeVaiTro();
  }

  determinativeVaiTro() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    if (typeof userInfo == 'undefined') {
      browserHistory.push('/');
    } else {
      this.setState({
        donViId: userInfo.donViId
      });
    }
  }

  componentDidMount() {
    this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    this.initHuongXuLyData(this.props.dataNextStates, 'dataNextState');
    if (this.props.tuGiaiQuyet == true && !this.props.donInfo.laTTXMLai) {
      this.initHuongXuLyData(this.props.dataNextStatesTXL, 'dataNextStatesTXL');
    }
  }

  initHuongXuLyData(inputData, name) {
    let ttxmText = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
    let ttxmText1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ttxmText+' và dự thảo văn bản GQ' : ttxmText;
    let outputData = [...inputData];
    outputData = outputData.map(item => {
      if (item.type == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
        return item = {...item,
          tenVietTat : 'Gửi báo cáo '+ttxmText1,
          ten : 'Gửi báo cáo '+ttxmText1
        }
      }
      if (item.type == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
        return item = {...item,
          tenVietTat : 'Trả đơn do chuyển '+ttxmText+' không đúng',
          ten : 'Trả đơn do chuyển '+ttxmText+' không đúng'
        }
      }
      return item;
    });
    this.setState({
      [name]: outputData
    });
  }

  componentWillReceiveProps(nextProps) {
    if(this.state.thongTinGiaiQuyetDonId != nextProps.thongTinGiaiQuyetDonId && nextProps.thongTinGiaiQuyetDonId) {
      this.setState({
        id: nextProps.id,
        thongTinGiaiQuyetDonId: nextProps.thongTinGiaiQuyetDonId
      });
      this.getThongTinGiaiQuyetDon(nextProps.thongTinGiaiQuyetDonId);
    }
    if(nextProps.dataNextStates != this.props.dataNextStates) {
      this.initHuongXuLyData(nextProps.dataNextStates, 'dataNextState');
    }
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });

    return pass;
  }

  getThongTinGiaiQuyetDon(id) {
    if(typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
      let params = {
        id: id
      };
      GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(res => {
        if(res.data) {
          let _noiDung = res.data.noiDung || '';
          if (this.props.donInfo && this.props.donInfo.laTTXMLai) {
            _noiDung = res.data.noiDungTraBaoCaoTTXMLan2 || '';
          }
          this.setState({
            dataGiaiQuyetDon: res.data,

            lapToDoanXacMinh: res.data.lapToDoanXacMinh,
            soQuyetDinhThanhLapDTXM: res.data.soQuyetDinhThanhLapDTXM,
            truongDoanTTXM: res.data.truongDoanTTXMInfo ? res.data.truongDoanTTXMInfo.congChucId : '',

            ketLuanNoiDungKhieuNaiGiaoTTXM: res.data.ketLuanNoiDungKhieuNaiGiaoTTXM ? res.data.ketLuanNoiDungKhieuNaiGiaoTTXM : '',
            lyDoQuaHan: res.data.lyDoQuaHan || '',
            noiDung: _noiDung,
            yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : '',

            giaHanTTXM: res.data.giaHanTTXM,
            giaHanGiaiQuyet: res.data.giaHanGiaiQuyet,

            nextState: res.data.nextStateInfo ? res.data.nextStateInfo.type : 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET',

            ngayHetHanSauKhiGiaHanTTXM: res.data.ngayHetHanSauKhiGiaHanTTXM ? moment(res.data.ngayHetHanSauKhiGiaHanTTXM).format('DD/MM/YYYY') : '',
            lyDoGiaHanTTXM: res.data.lyDoGiaHanTTXM ? res.data.lyDoGiaHanTTXM : '',
            ngayHetHanSauKhiGiaHanGiaiQuyet: res.data.ngayHetHanSauKhiGiaHanGiaiQuyet ? moment(res.data.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '',
            lyDoGiaHanGiaiQuyet: res.data.lyDoGiaHanGiaiQuyet ? res.data.lyDoGiaHanGiaiQuyet : ''
          },() => {
            if (this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
              this.checkFileRequired();
            }
            if (this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
              this.filterFileRequired();
            }
          });
        }
      });
    }
  }

  filterFileRequired() {
    let ListTaiLieuVanThuShow = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(state => {
      return state.nguoiTaoInfo.donViId != this.state.donViId
    });

    let dataFilter = ListTaiLieuVanThuShow.filter(state => {
      return state.typeRequired != 'BC_KQTTXM'
    })
    let dataFilter2 = this.state.ListTaiLieuVanThu.filter(state => {
      return state.typeRequired != 'BC_KQTTXM' && state.typeRequired != 'KQTTXM_DTVBGQ';
    })

    this.setState({
      ListTaiLieuVanThuShow: dataFilter,
      ListTaiLieuVanThu: dataFilter2,
      showAttach: true
    })
  }

  checkFileRequired() {
    let data = this.props.donInfo.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM.filter(state => {
      return state.nguoiTaoInfo.donViId == this.state.donViId
    });

    let dataShow = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(state => {
      return state.nguoiTaoInfo.donViId != this.state.donViId
    });
    if (this.props.loaiDon == 'DON_KHIEU_NAI' || this.props.loaiDon == 'DON_TO_CAO' || this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') {

      let isTTXML = this.props.donInfo && this.props.donInfo.laTTXMLai ? true : false;
      if (isTTXML == true) {
        dataShow = this.props.donInfo.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView.filter(item => {
          return item.typeRequired != 'BC_KQTTXM_L'
        });
        data = data.filter(item => {
          return item.typeRequired != 'BC_KQTTXM' && item.typeRequired != 'KQTTXM_DTVBGQ';
        });
      }
      let checkKQTTXM = data.filter(item => {
        if (isTTXML == true)
          return item.typeRequired == 'BC_KQTTXM_L';
        else
          return item.typeRequired == 'BC_KQTTXM';
      });
      if (checkKQTTXM.length == 0) {
        let itemKQTTXM = {
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          required: false,
          progress: 0,
          typeRequired: isTTXML == true ? 'BC_KQTTXM_L' : 'BC_KQTTXM',
          newFile: true
        }
        if (this.props.loaiDon == 'DON_TO_CAO') {
          itemKQTTXM.ten = 'Báo cáo Kết quả xác minh nội dung tố cáo'+(isTTXML == true ? ' (Lần 2)' : '');
        } else if (this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') {
          itemKQTTXM.ten = 'Văn bản xác minh đề xuất'+(isTTXML == true ? ' (Lần 2)' : '');
        } else {
          itemKQTTXM.ten = 'Báo cáo Kết quả xác minh nội dung khiếu nại'+(isTTXML == true ? ' (Lần 2)' : '');
        }
        data = [...data, itemKQTTXM];
      }

      if ((this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' || this.props.loaiDon == 'DON_TO_CAO') && this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
        let checkDTVBGQ = data.filter(item => {
          if (isTTXML == true)
            return item.typeRequired == 'KQTTXM_DTVBGQ_L';
          else
            return item.typeRequired == 'KQTTXM_DTVBGQ';
        });
        if (checkDTVBGQ.length == 0) {
          let itemDTVBGQ = {
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            ten: this.props.loaiDon == 'DON_TO_CAO' ? 'Dự thảo kết luận nội dung tố cáo' : 'Dự thảo văn bản giải quyết',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: false,
            typeRequired: isTTXML == true ? 'KQTTXM_DTVBGQ_L' : 'KQTTXM_DTVBGQ',
            newFile: true
          };
          data = [...data, itemDTVBGQ];
        }
      }
    }
    this.setState({
      ListTaiLieuVanThu: data,
      ListTaiLieuVanThuShow: dataShow,
      showAttach: true
    })

  }

  onClickClose() {
    this.props.handleBack();
  }

  handleSave() {
    this.setState({
      onSave: true
    }, () => {

      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });
      let dataFileDelete = [];
      if (this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' || this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
        this.state.dataFileDinhKem.forEach((item, i) => {
          if (item.taiLieuVanThuId) {
            this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
              don: {
                id: Number(this.state.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: item.loaiTepDinhKem,
              loaiQuyTrinh: item.loaiQuyTrinh,
              buocGiaiQuyet: item.buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
              don: {
                id: Number(this.state.id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: loaiTepDinhKem,
              loaiQuyTrinh: this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN' ? 'XU_LY_DON' : loaiQuyTrinh,
              buocGiaiQuyet: buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          }
        });

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.forEach(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }
      } else {
        let data = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
        data.filter(state => {
          return state.required && state.typeRequired == 'BC_KQTTXM_GQKN'
        }).map((item) => {
          dataFileDelete[dataFileDelete.length] = {
            id: item.taiLieuVanThuId
          }
        });
      }

      let params = this.getParams();

      if (this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' || this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
          this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
            this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
              this.props.saveGiaiQuyetDon(params, 'gqdLuu');
            });
          });
        });
      } else {
        this.deleteTaiLieuVanThu(dataFileDelete, () => {
          this.props.saveGiaiQuyetDon(params, 'gqdLuu');
        });
      }
    })
  }

  handleGiaiQuyetDon() {
    this.setState({
      onSave: false
    },()=> {
      if(this.validateSubmitForm()) {
        this.setState({
          btnLoading: true
        });
        let dataFileDelete = [];
        if (this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' || this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
          this.state.dataFileDinhKem.map((item, i) => {
            if (item.taiLieuVanThuId) {
              this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(this.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(this.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN' ? 'XU_LY_DON' : loaiQuyTrinh,
                buocGiaiQuyet: buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });

          if (this.state.dataTaiLieuVanThuDelete.length > 0) {
            this.state.dataTaiLieuVanThuDelete.map(item => {
              this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }
        } else {
          let data = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
          data.filter(state => {
            return state.required && state.typeRequired == 'BC_KQTTXM_GQKN'
          }).forEach((item) => {
            dataFileDelete[dataFileDelete.length] = {
              id: item.taiLieuVanThuId
            }
          })
        }

        let _params = this.getParams();
        let params = {};
        let msgName = '';
        let isQuaHan  = (this.props.donInfo.thoiHanTTXMInfo && this.props.donInfo.thoiHanTTXMInfo.value < 0) ? true : false;

        if (this.props.tuGiaiQuyet) {
          if(this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
            params = {
              thongTinGiaiQuyetDon: {
                id: Number(this.props.thongTinGiaiQuyetDonId)
              },
              actionType: 'TTXM_GUI_DON_VI_GIAI_QUYET',
              yKienGiaiQuyet: this.state.noiDung
            }
            if (isQuaHan == true) {
              params.lyDoQuaHan = this.state.lyDoQuaHan;
            }
            msgName = 'gqdTraBaoCao';
          } else {
            params = {
              thongTinGiaiQuyetDon: {
                id: Number(this.props.thongTinGiaiQuyetDonId)
              },
              actionType: 'TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN',
              yKienGiaiQuyet: this.state.yKienGiaiQuyet
            }
            msgName = 'gqdTraDonThanhCong';
          }
        } else {
          let selectedState = this.props.dataNextStates.filter(state => {
            return state.type == this.state.nextState
          });
          if(this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
            params = {
              thongTinGiaiQuyetDon: {
                id: Number(this.props.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              yKienGiaiQuyet: this.state.noiDung
            }
            if (isQuaHan == true) {
              params.lyDoQuaHan = this.state.lyDoQuaHan;
            }
            msgName = 'gqdTraBaoCao';
          } else {
            params = {
              thongTinGiaiQuyetDon: {
                id: Number(this.props.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              yKienGiaiQuyet: this.state.yKienGiaiQuyet
            }
            msgName = 'gqdTraDonThanhCong';
          }
        }
        if (this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' || this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
          this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
            this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
              this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
                this.props.updateGiaiQuyetDon(_params, params, msgName);
              });
            });
          });
        } else {
          this.deleteTaiLieuVanThu(dataFileDelete, () => {
            this.props.updateGiaiQuyetDon(_params, params, msgName);
          });
        }
      }
    })
  }

  // Cap nhat tep dinh kem
  updateTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Them tep dinh kem
  postTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Xoa tep dinh kem
  deleteTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  handleCheck(name, e) {
    this.setState({
      [name]: e
    })
    if (!e) {

    }
    this.props.handleChangeData();
  }

  onChange(name, e) {
    if (name == 'nextState' && e.target.value == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
      this.setState({
        showAttach: false,
        yKienGiaiQuyet: '',
        canBoGiaiQuyet: '',
        noiDung: '',
        ketLuanNoiDungKhieuNaiGiaoTTXM: '',
        [name]: e.target.value
      }, ()=> {
        this.checkFileRequired();
      })
    } else if (name == 'nextState' && e.target.value == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
      this.setState({
        yKienGiaiQuyet: '',
        canBoGiaiQuyet: '',
        noiDung: '',
        ketLuanNoiDungKhieuNaiGiaoTTXM: '',
        showAttach: false,
        [name]: e.target.value
      }, ()=> {
        this.filterFileRequired();
      })
    } else {
      this.setState({
        [name]: e.target.value
      });
    }
    if (name== 'nextState') {

    }
    this.props.handleChangeData();
  }

  onFileChange(data) {
    this.setState ({
      dataFileDinhKem: data
    });
    this.props.handleChangeData();
  }

  onFileRemove(id, data) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });
    this.setState ({
      dataFileDinhKem: data
    });
    this.props.handleChangeData();

  }

  getParams() {
    let dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
    let params = getParams(dataGiaiQuyetDon, this.state.id);
    params.ketLuanNoiDungKhieuNaiGiaoTTXM = this.state.ketLuanNoiDungKhieuNaiGiaoTTXM || null;
    if (this.props.donInfo && this.props.donInfo.laTTXMLai) {
      params.noiDungTraBaoCaoTTXMLan2 = this.state.noiDung;
    } else {
      params.noiDung = this.state.noiDung || '';
    }
    params.yKienGiaiQuyet = this.state.yKienGiaiQuyet || '';
    if (this.props.tuGiaiQuyet != true) {
      if(this.state.nextState) {
        let selectedState = this.props.dataNextStates.filter(state => {
          return state.type == this.state.nextState
        });
        params.nextState = {
          id: selectedState[0].stateId
        }
      } else {
        params.nextState = null
      }
    } else {
      if(this.state.nextState) {
        let selectedState = this.props.dataNextStatesTXL.filter(state => {
          return state.type == this.state.nextState
        });
        params.nextState = {
          id: selectedState[0].stateId
        }
      } else {
        params.nextState = null
      }
    }
    let isQuaHan  = (this.props.donInfo.thoiHanTTXMInfo && this.props.donInfo.thoiHanTTXMInfo.value < 0) ? true : false;
    if (isQuaHan == true) {
      params.lyDoQuaHan = this.state.lyDoQuaHan;
    }

    return params;
  }

  openDialog(name) {
    if (this.validateSubmitForm()) {
      this.setState({
        [name]: true
      })
    }
  }

  closeDialog(name) {
    this.setState({
      [name]: false
    })
  }

  onSuccess(name) {
    this.setState({
      [name]: false
    })
    this.handleGiaiQuyetDon();
  }

  render() {
    let lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
    let lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
    let lb3 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
    let lbGuiTTXM = 'Gửi báo cáo '+lb1;
    let lbTraTTXM = 'Trả đơn do chuyển '+lb1+' không đúng';
    let isQuaHan  = (this.props.donInfo.thoiHanTTXMInfo && this.props.donInfo.thoiHanTTXMInfo.value < 0) ? true : false;
    return (
      <section className="wrap-block">
        <NhiemVuTTXM
          donViGiaoThamTraXacMinh={this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo}
          ngayBatDauTTXM={this.state.dataGiaiQuyetDon.ngayBatDauTTXM}
          yKienCuaDonViGiaoTTXM = {this.state.dataGiaiQuyetDon.yKienCuaDonViGiaoTTXM}
          donInfo={this.props.donInfo}
          ngayHetHanTTXM={this.state.dataGiaiQuyetDon.ngayHetHanTTXM}/>
        <div className="wrap-big-line pt5 pb20">
          <span className="big-border"></span>
        </div>
        <div className="row pl10 pr10">
          <div className="col-100">
            <div className="col-100 no-gutter">
              <ShowIf condition={this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET'}>
                <h2 className="title-14 mb15">Báo cáo kết quả xác minh{lb2}</h2>
              </ShowIf>
              <ShowIf condition={this.state.nextState != 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET'}>
                <h2 className="title-14 mb15">Thông tin giải quyết</h2>
              </ShowIf>
              <div className="col-100 no-gutter">
                <ShowIf condition={this.props.loaiDon == 'DON_TO_CAO' && this.state.giaHanGiaiQuyet}>
                  <div className="col-100 no-gutter mt5">
                    <div className="row pl10 pr10">
                      <p className="txt-bold txt-upper mb10 pl5 pr5">Gia hạn giải quyết tố cáo</p>
                      <Text red={true} className="col-25 mb10" label="Gia hạn đến ngày:" value={this.state.ngayHetHanSauKhiGiaHanGiaiQuyet ? moment(this.state.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : ''}/>
                      <TextMessage className="col-100 mb15" label="Lý do gia hạn:" value={this.state.lyDoGiaHanGiaiQuyet}/>
                      <div className="col-100 pb15">
                        <span className="line-border"></span>
                      </div>
                    </div>
                  </div>
                </ShowIf>
                <div className='row pl10 pr10'>
                  <ShowIf condition={this.state.dataNextState.length > 1}>
                    <DropDownMulipleUse
                      onRef={select => (this.select = select)}
                      className="col-25"
                      donId={this.state.id}
                      isValid={this.state.validate}
                      data={this.state.dataNextState}
                      placeholder={null}
                      keyName='type'
                      valueName='tenVietTat'
                      label="Hướng giải quyết"
                      name="huongGiaiQuyet"
                      selectedValue={this.state.nextState}
                      onChange={this.onChange.bind(this, 'nextState')}/>
                  </ShowIf>
                  <ShowIf condition={this.props.tuGiaiQuyet == true && !this.props.donInfo.laTTXMLai}>
                    <DropDownMulipleUse
                      onRef={select => (this.select = select)}
                      className="col-25"
                      donId={this.state.id}
                      isValid={this.state.validate}
                      data={this.state.dataNextStatesTXL}
                      placeholder={null}
                      keyName='type'
                      valueName='tenVietTat'
                      label="Hướng giải quyết"
                      name="huongGiaiQuyet"
                      selectedValue={this.state.nextState}
                      onChange={this.onChange.bind(this, 'nextState')}/>
                  </ShowIf>
                  <ShowIf condition={this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET'}>
                    <TextArea className="col-100" label="Ý kiến xử lý" value={this.state.noiDung} placeholder="Nhập..." onChange={this.onChange.bind(this, 'noiDung')} name="textareaCanBoKetLuanNoiDung"/>
                    {
                      isQuaHan == true &&
                      <TextArea className="col-100" label="Lý do quá hạn" bindValidator={this} channel='formTaoDon' require value={this.state.lyDoQuaHan} placeholder="Nhập..." onChange={this.onChange.bind(this, 'lyDoQuaHan')} name="TextAreaLyDoQuaHan" maxLength={1000}/>
                    }
                  </ShowIf>
                  <ShowIf condition={this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN'}>
                    <TextArea bindValidator={this} channel='formTaoDon' require className="col-100" label="Lý do" placeholder="Nhập..." value={this.state.yKienGiaiQuyet} onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="textareaCanBoKetLuanNoiDung" maxLength={1000}/>
                  </ShowIf>
                </div>
              </div>
            </div>
            <ShowIf condition={this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' || this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN'}>
              <ShowIf condition={this.state.showAttach}>
                <div className="col-100 no-gutter pb5">
                  <ContainerFileDinhKem onSave={this.state.onSave} dataShow={this.state.ListTaiLieuVanThuShow} data={this.state.ListTaiLieuVanThu} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                </div>
              </ShowIf>
            </ShowIf>
            <ShowIf condition={this.state.nextState != 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' && this.state.nextState != 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN'}>
              <ShowIf condition={this.state.showAttach}>
                <div className="col-100 no-gutter pb5">
                  <ContainerFileDinhKem  dataShow={this.state.ListTaiLieuVanThuShow} hideDescription={true} disableAttachFile={true}/>
                </div>
              </ShowIf>
            </ShowIf>
          </div>
          <div className='col-100'>
            <div className="box-bottom">
              <div className="wrap-big-line mt10 mb20"><div className="line-border"></div></div>
              <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
              <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this)}><span>Lưu tạm</span></Link>
              <ShowIf condition={this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET'}>
                <Link style={{right: 0}} className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline') : "btn-action btn-move action-todo"} onClick={this.openDialog.bind(this, 'openDialog')}><span>{lbGuiTTXM}</span></Link>
              </ShowIf>
              <ShowIf condition={this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN'}>
                <Link style={{right: 0}} className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline') : "btn-action btn-move action-todo"} onClick={this.openDialog.bind(this, 'openDialogTraDon')}><span>{lbTraTTXM}</span></Link>
              </ShowIf>
              <ConfirmDialog open={this.state.openDialog} onClose={this.closeDialog.bind(this, 'openDialog')} onSuccess={this.onSuccess.bind(this, 'openDialog')} title="Xác nhận" content={"Bạn có đồng ý chuyển cho " + (this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.ten : '') +" báo cáo "+lb3+" của đơn/vụ việc này không?"}/>
              <ConfirmDialog open={this.state.openDialogTraDon} onClose={this.closeDialog.bind(this, 'openDialogTraDon')} onSuccess={this.onSuccess.bind(this, 'openDialogTraDon')} title="Xác nhận" content={`Bạn có đồng ý trả đơn/vụ việc chuyển ${lb1} không đúng này cho ${this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.ten : ''} không?`}/>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

NhapThongTinToTTXX.defaultProps = {
  validators: {formTaoDon:[]},
  dataNextStatesTXL: [
    {
      type: 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN',
      stateId: 39,
      tenVietTat: 'Trả đơn do chuyển TTXM không đúng'
    },
    {
      type: 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET',
      stateId: 15,
      tenVietTat: 'Gửi báo cáo TTXM'
    },
  ],
  donInfo: {},
  listTaiLieuVanThuGiaiQuyetDon: []
}

export default NhapThongTinToTTXX;



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/NhapThongTinToTTXX.jsx